import { Heading, Spacer, Video } from '@sparemin/blockhead';
import React from 'react';
import ProgressOverlay from 'components/ProgressOverlay';
import {
  useAspectRatio,
  useFileArchiveInfo,
  useIsRegeneratingProject,
  useIsStatusNullOrUndefined,
  useProjectWidgetId,
} from './ProjectPreviewModalContext';
import ProjectPreviewModalVideoStatusLabel from './ProjectPreviewModalVideoStatusLabel';
import { block } from './utils';

export interface ProjectPreviewModalVideoStatusProps {}

const ProjectPreviewModalVideoStatus: React.FC<ProjectPreviewModalVideoStatusProps> = () => {
  const widgetId = useProjectWidgetId();
  const isRegeneratingProject = useIsRegeneratingProject();
  const isStatusNullOrUndefined = useIsStatusNullOrUndefined();
  const aspectRatio = useAspectRatio();
  const { isRestoreInProgress } = useFileArchiveInfo();

  const isNotExported = !widgetId || isStatusNullOrUndefined;
  const isRegenerating = isRegeneratingProject || isRestoreInProgress;

  return (
    <div className={block('preview-container')}>
      <Spacer
        space="16px"
        orientation="vertical"
        align="center"
        justify="center"
        className={block('video-status', {
          [aspectRatio]: true,
          'not-exported': isNotExported,
          regenerating: isRegenerating,
        })}
      >
        {!isRestoreInProgress && (
          <ProjectPreviewModalVideoStatusLabel>
            {label => (
              <>
                <Video width="62px" height="40px" />

                <Heading
                  level={4}
                  align="center"
                  letterSpacing="2px"
                  weight="bold"
                  textTransform="uppercase"
                  className={block('restoring-label')}
                >
                  {label}
                </Heading>
              </>
            )}
          </ProjectPreviewModalVideoStatusLabel>
        )}

        {isRegenerating && (
          <div className={block('regenerating')}>
            <ProgressOverlay in />

            <ProjectPreviewModalVideoStatusLabel>
              {label => (
                <Heading
                  level={1}
                  align="center"
                  className={block('regenerating-label', {
                    [aspectRatio]: true,
                    restoring: isRestoreInProgress,
                  })}
                >
                  {label}
                </Heading>
              )}
            </ProjectPreviewModalVideoStatusLabel>
          </div>
        )}
      </Spacer>
    </div>
  );
};

export default ProjectPreviewModalVideoStatus;
